import { makeAutoObservable } from 'mobx'
import { type INormalizedApiError } from 'shared/api'
import {
  AgentActions,
  type IAgentActionSettings,
  type IAgentActionType,
} from 'entities/AgentActions'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { AgentActionsControl } from 'widgets/AgentActions'
import { FallbackAgentActionsErrors } from './fallbackAgentActionsErrors'

export class FallbackAgentActionsStore {
  private readonly _model = new AgentActions()
  private readonly _errors = new FallbackAgentActionsErrors('fallback_action')
  private readonly _control: AgentActionsControl

  constructor(entities: IEntitiesStore) {
    this._control = new AgentActionsControl(this._model, entities)
    makeAutoObservable(this)
  }

  init = (value: IAgentActionSettings[] | null | undefined) => {
    this._model.syncOrigin(value ?? [])
    this._errors.clear()
  }

  get control() {
    return this._control
  }

  get errors() {
    return this._errors
  }

  get hasActions() {
    return this._control.list.length > 0
  }

  get sectionError() {
    return this._errors.sectionError
  }

  createAction = (type: IAgentActionType) => {
    this._control.createAction(type)
  }

  syncApiErrors = (apiErrors: INormalizedApiError | null | undefined) => {
    this._errors.sync(apiErrors, this._model)
  }

  resetSectionError = () => {
    if (this._errors.hasOwnSectionError) this._errors.removeSectionError()
  }

  dispose = () => {
    this._control.dispose()
  }

  get paramsValue(): IAgentActionSettings[] | null {
    const list = this._model.toJSON()
    return list.length > 0 ? list : null
  }
}
